import { createElement, Component } from 'react';
import { d as _inheritsLoose, e as _defineProperty, f as _assertThisInitialized } from './_rollupPluginBabelHelpers-cb1cd42c.js';
import 'reakit-system';
import 'reakit';
import { ErrorMessage } from './ErrorMessage.js';

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null
    });

    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(_) {// do nothing
  };

  _proto.render = function render() {
    if (this.state.error) {
      return /*#__PURE__*/createElement(ErrorMessage, {
        error: this.state.error
      });
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(Component);

export { ErrorBoundary };
